import { component } from 'picoapp'
import $ from '../lib/quantdom'

export default component((node) => {
  const tabs = $(node).parent().findEls('[role="tab"')

  const toggleTab = (target) => {
    const tab = $(target).attr('aria-controls')
    $('.js-details-tab').attr('aria-selected', false)
    $('.js-details-tab-header').attr('aria-selected', false)
    $('.js-details-tab-header').attr('tabindex', '-1')
    $(target).attr('aria-selected', true)
    $(target).attr('tabindex', '0')
    $(`#${tab}`).attr('aria-selected', true)
  }

  $(node).on('keydown', (e) => {
    let newTab

    tabs.forEach((element, idx, array) => {
      if (e.target === element && e.code === 'ArrowRight') newTab = array[idx + 1] || array[0]
      if (e.target === element && e.code === 'ArrowLeft') newTab = array[idx - 1] || array[array.length - 1]
    })

    if (newTab) {
      toggleTab(newTab)
      newTab.focus()
    }
  })

  $(node).on('click', (e) => toggleTab(e.target))
})
